import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "opentil:mode"
const MODES = ["agent", "human"]
const DEFAULT_MODE = "human"

export default class extends Controller {
  static targets = ["btn", "panel"]

  connect() {
    this.mode = this.#resolveInitialMode()
    this.#apply()
  }

  switch(event) {
    const mode = event.currentTarget.dataset.mode
    if (!MODES.includes(mode) || mode === this.mode) return

    this.mode = mode
    this.#apply()
    this.#persist()
    this.#broadcast()
  }

  synced = (event) => {
    if (event.detail?.source === this.element) return
    const mode = event.detail?.mode
    if (MODES.includes(mode) && mode !== this.mode) {
      this.mode = mode
      this.#apply()
    }
  }

  // --- private ---

  #resolveInitialMode() {
    const params = new URLSearchParams(window.location.search)
    const urlMode = params.get("mode")
    if (MODES.includes(urlMode)) return urlMode

    try { const stored = localStorage.getItem(STORAGE_KEY); if (MODES.includes(stored)) return stored } catch {}


    return DEFAULT_MODE
  }

  #apply() {
    this.btnTargets.forEach(btn => {
      const isActive = btn.dataset.mode === this.mode
      btn.classList.toggle("active", isActive)
      btn.setAttribute("aria-selected", isActive)
    })

    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.mode === this.mode
      panel.classList.toggle("is-active", isActive)
      panel.setAttribute("aria-hidden", !isActive)
    })
  }

  #persist() {
    try { localStorage.setItem(STORAGE_KEY, this.mode) } catch {}
    const url = new URL(window.location)
    url.searchParams.set("mode", this.mode)
    history.replaceState(null, "", url)
  }

  #broadcast() {
    window.dispatchEvent(new CustomEvent("mode-toggle:changed", {
      detail: { mode: this.mode, source: this.element }
    }))
  }
}
